import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FlexLayoutModule} from '@angular/flex-layout';
import {InputMaskModule} from '@ngneat/input-mask';
import {LoanTermsSelectionComponent} from './loan-terms-selection.component';
import {BusinessLoanTermsSelectionComponent} from './business-loan-terms-selection.component';
import {AngularMaterialLibraryModule} from '../../angular-material/angular-material-library.module';
import {DirectiveLibraryModule} from '../../directives/directive-library.module';
import { LoanTermsSelectionWithInputComponent } from './loan-terms-selection-with-input.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        InputMaskModule,
        AngularMaterialLibraryModule,
        DirectiveLibraryModule,
        LoanTermsSelectionComponent,
        BusinessLoanTermsSelectionComponent,
        LoanTermsSelectionWithInputComponent,
    ],
    exports: [
        LoanTermsSelectionComponent,
        BusinessLoanTermsSelectionComponent,
        LoanTermsSelectionWithInputComponent,
    ]
})
export class LoanTermsSelectionModule {

}
